import { useMemo } from 'react';
import { FiClock, FiHome, FiSearch, FiSlack, FiUser, FiZap } from 'react-icons/fi';
import { NavLinkItem } from '../helper';
import routesMap from '../routesMap';

const navs: Array<NavLinkItem> = [
  {
    name: 'Trang chủ',
    key: routesMap.HOME,
    icon: FiHome,
  },
  {
    name: 'Khách hàng',
    key: routesMap.CUSTOMER,
    icon: FiUser,
  },
  {
    name: 'Liệu trình',
    key: routesMap.PROCESS,
    icon: FiZap,
  },
  {
    name: 'Tra cứu',
    key: routesMap.SEARCH,
    icon: FiSearch,
  },
  {
    name: 'Danh sách thuốc',
    key: routesMap.MEDICINE,
    icon: FiSlack,
  },
  {
    name: 'Lịch sử hoạt động',
    key: routesMap.ACTIVITY_LOG,
    icon: FiClock,
  },
];

export function useNavs() {
  return useMemo(() => {
    const accessToken = JSON.parse(localStorage.getItem("access_token") || "null");
    let visible = navs;
    if (accessToken?.role === 'onlyadd') {
      visible = visible.filter((nav) => nav.key !== routesMap.ACTIVITY_LOG);
    }
    return visible;
  }, []);
}